import $ from "jquery";
import "select2";

const classSelect2 = () => {
  const init = () => {
    execute();
  };

  const execute = () => {
    const el = {
      select: ".js-class-select2",
      select2: "#merk-select",
    };

    $(window).on('load', function () {
      $(el.select).select2({
        dropdownCssClass: 'dropdownMaxContent',
      })
    })
  };

  init();
};

try {
  classSelect2();
} catch (error) {
  console.error("classSelect2: ", classSelect2);
}
